import axiosClient from "../api/axios";

export const trackPageView = async () => {
  try {
    await axiosClient.post("/api/analytics/", {
      event_type: "page_view",
      timestamp: new Date().toISOString(),
    });
    
    console.log("count",JSON.stringify({
        event_type: 'page_view',
        timestamp: new Date().toISOString(),
      }))
  } catch (err) {
    console.error('Failed to track page view:', err);
  }
};
